"use client"

import React from "react"
import { cn } from "@/lib/utils"
import styles from "./global-loader.module.css"

interface GlobalLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: string
    subtitle?: string
}

export function GlobalLoader({
    title = "Loading...",
    subtitle,
    className,
    ...props
}: GlobalLoaderProps) {
    return (
        <div
            className={cn(
                "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white",
                className
            )}
            {...props}
        >
            <div className="flex flex-col items-center justify-center space-y-16">
                {/* 3D Box Loader HTML */}
                <div className={styles.boxes}>
                    <div className={styles.box}>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className={styles.box}>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className={styles.box}>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className={styles.box}>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

                {/* Text Content */}
                <div className="text-center mt-8 space-y-2 max-w-sm px-4">
                    <h3 className="text-2xl font-semibold text-slate-900 tracking-tight animate-fade-in">
                        {title}
                    </h3>
                    {subtitle && (
                        <p className="text-lg text-slate-500 animate-fade-in delay-75">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}
